import { LoadablePaint } from '@confluence/loadable';

export const HomeWelcomeMessage = LoadablePaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-WelcomeMessage" */ './WelcomeMessage'))
			.HomeWelcomeMessage,
});
